import reactLogo from "../ui/images/react-logo.png";
import restApiLogo from "../ui/images/rest-rpc-logo.png";
import tsLogo from "../ui/images/ts-logo.png";
import webDevLogo from "../ui/images/web-dev-logo.png";
import unitTestsLogo from "../ui/images/unit-tests-logo.png";
import dockerLogo from "../ui/images/docker-logo.png";
import kuberLogo from "../ui/images/kuber-logo.png";

export const SkillsData = [
    {
        name: "React",
        description: "6/10",
        logoUrl: reactLogo
    },
    {
        name: "JS (TS)",
        description: "7/10",
        logoUrl: tsLogo
    },
    {
        name: "CSS/HTML",
        description: "7/10",
        logoUrl: webDevLogo
    },
    {
        name: "REST API/RPC",
        description: "8/10",
        logoUrl: restApiLogo
    },
    {
        name: "Unit-tests",
        description: "8/10",
        logoUrl: unitTestsLogo
    },
    {
        name: "Docker",
        description: "5/10",
        logoUrl: dockerLogo
    },
    {
        name: "Kubernetes",
        description: "3/10",
        logoUrl: kuberLogo
    }
];
